import { JT } from "./jumbotronTokens";

// #1166 D2.1: which game a leg is on, when more than one same-matchup game is
// possible. Presentational only -- the caller owns state and propagation.
const selectStyle = { width: "100%", background: "transparent", border: "none", borderBottom: `1px dashed ${JT.text.dim}`, outline: "none", padding: "4px 0", color: JT.text.tertiary, fontSize: 11, fontFamily: "inherit", boxSizing: "border-box", appearance: "auto" };
const STATUS_LABEL = { FINAL: "Final", OFF: "Final", LIVE: "Live", UPCOMING: "Upcoming", DELAYED: "Upcoming" };
const EDIT_ACCENT = "#f59e0b"; // mirrors features/import EDIT_ACCENT; ui/ must not import features/

// "Tue Oct 7" (D2.1 mockup): built from parts so no locale comma follows the weekday.
function formatDay(date, opts = {}) {
  const parts = {};
  for (const p of new Intl.DateTimeFormat(undefined, { weekday: "short", month: "short", day: "numeric", ...opts }).formatToParts(date)) parts[p.type] = p.value;
  return `${parts.weekday} ${parts.month} ${parts.day}`;
}

export function formatCandidateLabel(c) {
  const status = STATUS_LABEL[String(c.status || "").toUpperCase()] || String(c.status || "");
  const start = c.startTime ? new Date(c.startTime) : null;
  if (start && Number.isFinite(start.getTime())) {
    const t = start.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
    return `${formatDay(start)}, ${t} · ${status}`;
  }
  const gd = c.gameDate ? new Date(`${c.gameDate}T12:00:00Z`) : null;
  const d = gd && Number.isFinite(gd.getTime()) ? formatDay(gd, { timeZone: "UTC" }) : "";
  return `${d} · ${status}`;
}
// Same focus ring as the confirm sheet's other fields (features/import focusRing);
// ui/ must not import features/, so it is mirrored here.
const focusRing = (e) => { e.target.style.outline = `1px solid ${JT.border.mid}`; };
const blurRing = (e) => { e.target.style.outline = "none"; };

export default function GamePicker({ candidates, value, onChange, edited }) {
  if (!Array.isArray(candidates) || candidates.length < 2) return null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 2, minHeight: 44, borderLeft: edited ? `3px solid ${EDIT_ACCENT}` : "none", paddingLeft: edited ? 6 : 0 }}>
      <select aria-label="Game" value={value || ""} onChange={(e) => onChange(e.target.value)} onFocus={focusRing} onBlur={blurRing} style={{ ...selectStyle, color: value ? JT.text.tertiary : JT.text.secondary }}>
        {!value && <option value="" disabled>Choose game…</option>}
        {candidates.map((c) => <option key={c.id} value={c.id}>{formatCandidateLabel(c)}</option>)}
      </select>
      {edited && <span style={{ fontSize: 11, color: EDIT_ACCENT, fontWeight: 600, whiteSpace: "nowrap" }}>edited</span>}
    </div>
  );
}
